import { registerAdditionalProjectionsIncludingEpsg28992 } from "./app/gis/projections";

// registerAdditionalProjectionsIncludingEpsg28992 must be called BEFORE StratopoMapViewer is imported!
registerAdditionalProjectionsIncludingEpsg28992();

import { StratopoMapViewer } from "./app/stratopomapviewer";
import "./styles/mapviewer.scss";

(window as any).StratopoMapViewer = StratopoMapViewer;
